import React from 'react';
import { BookOpen, Utensils, Activity, ShoppingCart, MapPin } from 'lucide-react';
export function WhatYouGet() {
  const deliverables = [{
    icon: <BookOpen className="w-6 h-6 text-sage-dark" data-id="element-170" />,
    title: 'Guía Digital "Protocolo Vientre Plano 40+"',
    desc: 'El paso a paso para desinflamar tu cuerpo desde la raíz hormonal.'
  }, {
    icon: <Utensils className="w-6 h-6 text-sage-dark" data-id="element-171" />,
    title: 'Plan de Alimentación de 14 Días',
    desc: 'Menús diarios diseñados para la mujer latina, con ingredientes que encuentras fácilmente en el supermercado.'
  }, {
    icon: <Activity className="w-6 h-6 text-sage-dark" data-id="element-172" />,
    title: 'La Técnica del Nervio Vago',
    desc: 'Un ejercicio de 5 minutos al despertar para reprogramar tu metabolismo.'
  }, {
    icon: <ShoppingCart className="w-6 h-6 text-sage-dark" data-id="element-173" />,
    title: 'Lista de Compras Inteligente',
    desc: 'Guía específica para Walmart, Target o Publix para que no gastes dinero en lo que no necesitas.'
  }, {
    icon: <MapPin className="w-6 h-6 text-sage-dark" data-id="element-174" />,
    title: 'Cheat Sheet de Restaurantes',
    desc: 'Cómo comer fuera sin inflamar tu vientre al instante.'
  }];
  return <section className="bg-white py-16 md:py-24 px-6" data-id="element-175">
      <div className="text-container" data-id="element-176">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-177">
          Todo lo que recibes hoy
        </h2>

        <div className="space-y-6" data-id="element-178">
          {deliverables.map((item, index) => <div key={index} className="flex items-start gap-6 p-6 rounded-2xl bg-cream border border-sage-light/50 hover:shadow-soft transition-shadow" data-id="element-179">
              <div className="bg-white p-4 rounded-full shadow-sm" data-id="element-180">
                {item.icon}
              </div>
              <div data-id="element-181">
                <h3 className="text-xl font-bold text-charcoal-dark mb-2 font-sans" data-id="element-182">
                  {item.title}
                </h3>
                <p className="text-charcoal-light text-lg" data-id="element-183">{item.desc}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}